import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TabSwitchProps {}
export const TabSwitch: React.FC<TabSwitchProps> = props => {
    return <div>{props.children}</div>;
};
